/* TextUnderline.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { useEffect, useRef, useState } from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _29 = "._j7hqzu28{animation-name:strokeright}";
const _28 = "._1kni13yj svg{-webkit-margin-end:var(--_jhy30s);margin-inline-end:var(--_jhy30s)}";
const _27 = "._cjf713yj svg{-webkit-margin-start:var(--_jhy30s);margin-inline-start:var(--_jhy30s)}";
const _26 = "._u7co11y5{inset-block-end:var(--_1jmpxqi)}";
const _25 = "._1pby1mrw{z-index:-1}";
const _24 = "._5sagpwmj{animation-duration:.7s}";
const _23 = "._mkrz16t8{-webkit-clip-path:polygon(0 0,0 0,0 100%,0 100%);clip-path:polygon(0 0,0 0,0 100%,0 100%)}";
const _22 = "._1bsb1osq{width:100%}";
const _21 = "._1e0c1txw{display:flex}";
const _20 = "._1e02idpf{inset-inline-start:0}";
const _19 = "._kqswstnw{position:absolute}";
const _18 = "._k48p103h{font-weight:var(--_1bgzcf7)}";
const _17 = "._lcxvglyw{pointer-events:none}";
const _16 = "._3um015vq{visibility:hidden}";
const _15 = "._j7hq1dkr{animation-name:boldin}";
const _14 = "@keyframes boldin{0%{font-weight:var(--_15xzfe0)}to{font-weight:var(--_1bgzcf7)}}";
const _13 = "@keyframes strokeright{0%{-webkit-clip-path:polygon(0 0,0 0,0 100%,0 100%);clip-path:polygon(0 0,0 0,0 100%,0 100%)}to{-webkit-clip-path:polygon(0 0,100% 0,100% 100%,0 100%);clip-path:polygon(0 0,100% 0,100% 100%,0 100%)}}";
const _12 = "._1nmz1hna{word-break:break-word}";
const _11 = "._vwz4kb7n{line-height:1}";
const _10 = "._1o51q7pw{animation-fill-mode:forwards}";
const _9 = "._tip8kb7n{animation-iteration-count:1}";
const _8 = "._5sagfnf5{animation-duration:.2s}";
const _7 = "._ju251bs3{animation-delay:.5s}";
const _6 = "._kqswh2mm{position:relative}";
const _5 = "._1e0c116y{display:inline-flex}";
const _4 = "._18u0idpf{margin-left:0}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._2hwxidpf{margin-right:0}";
const _ = "._19pkidpf{margin-top:0}";
const textStyle = null;
const inViewTextStyle = null;
const underlineStyle = null;
const inViewUnderlineStyle = null;
const hiddenText = null;
const visibleText = null;
export const TextUnderline = _ref => {
  let {
    text,
    children,
    underline,
    underlineInset = '-37.5%',
    underlineLeft = false,
    fontWeight = {
      from: 400,
      to: 800
    },
    useInViewOptions
  } = _ref;
  const scrollRef = useRef(null);
  const [sectionIsVisible, setSectionIsVisible] = useState(false);
  useEffect(() => {
    const node = scrollRef.current;
    if (!node) {
      return;
    }
    const observer = new IntersectionObserver(_ref2 => {
      let [entry] = _ref2;
      setSectionIsVisible(entry.isIntersecting);
    }, useInViewOptions);
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options expected to be stable or memoized by caller
  }, [useInViewOptions]);
  const fontWeightAnimation = null;
  const underlineInsetStyle = null;
  const toFontWeight = null;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15]
    }), /*#__PURE__*/_jsxs("span", {
      ref: scrollRef,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c116y _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna", sectionIsVisible && "_j7hq1dkr"]),
      style: {
        "--_15xzfe0": ix(fontWeight.from),
        "--_1bgzcf7": ix(fontWeight.to)
      },
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_16, _17, _18]
        }), /*#__PURE__*/_jsx("span", {
          "aria-hidden": true,
          className: ax(["_3um015vq _lcxvglyw", "_k48p103h"]),
          style: {
            "--_1bgzcf7": ix(fontWeight.to)
          },
          children: text !== null && text !== void 0 ? text : children
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_19, _20]
        }), /*#__PURE__*/_jsx("span", {
          className: ax(["_kqswstnw _1e02idpf"]),
          children: text !== null && text !== void 0 ? text : children
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_21, _22, _23, _7, _24, _9, _20, _10, _19, _25, _26, _27, _28, _29]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw", "_u7co11y5 _cjf713yj _1kni13yj", sectionIsVisible && "_j7hqzu28"]),
          style: {
            "--_1jmpxqi": ix(underlineInset),
            "--_jhy30s": ix(underlineLeft ? '0' : 'auto')
          },
          children: underline
        })]
      })]
    })]
  });
};